import React from "react";

import QueryOAuthIcon from "@mui/icons-material/VpnKey";

function OAuthIcon({ iconColor, iconSize = "small", ...other }) {
    return <QueryOAuthIcon color={iconColor} fontSize={iconSize} {...other} />;
}

export default OAuthIcon;
